import { render, staticRenderFns } from "./PhoneNumberStage.vue?vue&type=template&id=7a71577c&scoped=true"
import script from "./PhoneNumberStage.vue?vue&type=script&lang=js"
export * from "./PhoneNumberStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a71577c",
  null
  
)

export default component.exports